import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RedacaoService} from '@app/services/redacao.service';
import {AgendamentoRedacao, RedacaoResumido, SalvarFotoCommand, SalvarRedacaoCommand} from '@app/models/redacao';
import {AutenticacaoService} from '@app/services/autenticacao.service';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {CountdownConfig, CountdownEvent} from 'ngx-countdown';
import {Observable, Subject} from 'rxjs';
import {WebcamImage, WebcamInitError} from 'ngx-webcam';
import Swal from 'sweetalert2';
import {retry} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SisrhService} from '@app/services/sisrh.service';
import {DadosCandidato} from '@app/models/sisrh.model';
import {fromPromise} from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-fazer-redacao',
  templateUrl: './fazer-redacao.page.html',
  styleUrls: ['./fazer-redacao.page.scss']
})
export class FazerRedacaoPage implements OnInit {
  @ViewChild('modalRedacaoFoto', {static: false}) modalRedacaoFoto;
  idVaga: string;
  idRedacao: string;
  redacao: RedacaoResumido;
  agendamento: AgendamentoRedacao;
  informacoesVaga: any;
  informacoesCandidato: DadosCandidato;
  formulario: FormGroup;
  configuracaoTimer: CountdownConfig;
  trigger: Subject<void> = new Subject<void>();
  triggerModal: Subject<void> = new Subject<void>();
  umMinuto = 1 * 60 * 1000;
  dezMinutos = this.umMinuto * 10;
  trintaMinutos = this.umMinuto * 30;
  webcamImage: WebcamImage;
  descricaoFoto;
  readonly descricoesFoto = {
    duranteRedacao: 'Durante a prova(sem interação do aluno)',
    finalizacao: 'Final da prova'
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RedacaoService,
    private sisrhService: SisrhService,
    private autenticacaoService: AutenticacaoService,
    public ngbModal: NgbModal,
  ) {
  }

  ngOnInit() {
    this.idVaga = this.route.snapshot.queryParamMap.get('idVaga');
    this.idRedacao = this.route.snapshot.queryParamMap.get('idRedacao');
    this.descricaoFoto = this.descricoesFoto.duranteRedacao;

    if (this.idVaga == null || this.idRedacao == null) {
      this.router.navigateByUrl('/vagas/lista');
    }

    this.configurarEventos();
    this.configurarFormulario();
    this.buscarDados();
  }

  buscarDados() {
    this.service.buscarRedacaoResumido(this.idRedacao, this.idVaga).subscribe(data => {
      if (data == null) {
        this.router.navigateByUrl('/vagas/lista');
        return;
      }
      this.redacao = data;
      this.agendamento = data.agendamento;
      this.formulario.patchValue({
        questao: this.redacao.tema.descricao
      });

      this.verificarPermissoes();
      this.configurarTimer();
    });

    this.sisrhService.detalhesVaga(this.idVaga).subscribe(data => {
      this.informacoesVaga = data;
    });

    this.sisrhService.BuscarDadosCandidato(this.autenticacaoService.getValorUsuarioAtualCandidato.cpf,
      this.autenticacaoService.getTokenCandidato()
    ).subscribe(data => {
      this.informacoesCandidato = data;
    });
  }

  configurarFormulario() {
    this.formulario = new FormGroup({
      questao: new FormControl(null, Validators.required),
      resposta: new FormControl('', Validators.required),
    });

    this.formulario.get('questao').disable();
  }

  caracteresRestantes() : number {
    return this.formulario.get('resposta').value.length;
  }

  configurarTimer() {
    const dataAtual = new Date().toISOString().split('T')[0];
    const dataAgendamento = this.agendamento.dataAgendamento.split('T')[0];
    const horarioLimite = new Date(dataAgendamento + 'T' + this.agendamento.horarioFinal + '.00-0300');
    const horarioInicio = new Date(this.redacao.horarioInicio + '.00-0300');
    const segundosRestantes = (horarioLimite.getTime() - horarioInicio.getTime()) * 1000;

    if (segundosRestantes <= 0 || dataAtual !== dataAgendamento) {
      this.router.navigateByUrl('/vagas/lista');
    }

    const pausas = [];

    for (let i = new Date(), j = this.dezMinutos; i < horarioLimite; i = new Date(i.getTime() + this.dezMinutos), j += this.dezMinutos) {
      pausas.push(j / 1000);
    }

    pausas.push(this.trintaMinutos / 1000);

    this.configuracaoTimer = {
      stopTime: horarioLimite.getTime(),
      notify: pausas,
      format: 'HH:mm:ss'
    };
  }

  handleTimerEvent($event: CountdownEvent) {
    if ($event.action === 'notify') {
      this.triggerSnapshot();
      if ($event.left === this.trintaMinutos) {
        Swal.fire({
          title: 'Atenção',
          text: 'Faltam 30 minutos para o final da prova. Se o tempo acabar e você não enviar a prova, sua nota será zero.',
          icon: 'warning',
        });
      }
    } else if ($event.action === 'done') {
      Swal.fire({
        title: 'Atenção',
        text: 'Seu tempo acabou.',
        icon: 'warning',
        timer: 5000
      }).then(() => {
        this.enviarRedacao();
      });
    }
  }

  triggerSnapshot(): void {
    this.trigger.next();
  }

  handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;

    const command: SalvarFotoCommand = {
      idRedacao: this.idRedacao,
      base64Imagem: webcamImage.imageAsBase64,
      descricao: this.descricaoFoto
    };

    this.service.salvarFoto(command).pipe(retry(3)).subscribe();
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get triggerObservableModal(): Observable<void> {
    return this.triggerModal.asObservable();
  }


  configurarEventos() {
    document.addEventListener('copy', event => {
      event.preventDefault();
    });
    document.addEventListener('paste', event => {
      event.preventDefault();
    });
    document.addEventListener('cut', event => {
      event.preventDefault();
    });
  }

  enviarRedacao() {

    let mostrarBotao = false;
    let horarioLimite = new Date(this.agendamento.dataAgendamento.split('T')[0] + 'T' + this.agendamento.horarioFinal + '.00-0300');

    if (new Date() < horarioLimite ) {
      mostrarBotao = true;
    }

    Swal.fire({
      title: 'Atenção',
      text: 'Prezado (a) candidato (a), Tem certeza que gostaria de finalizar sua redação? Ressaltamos que o mínimo é de 800 carácteres e máximo de 1200.',
      icon: 'warning',
      showCancelButton: mostrarBotao,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO',
    }).then((result) => {
      if (!result.isConfirmed) {
        return false;
      }
      else {
        const command: SalvarRedacaoCommand = {
          idRedacao: this.idRedacao,
          texto: this.formulario.get('resposta').value
        };

        this.service.salvarRedacao(command).pipe(retry(3)).subscribe(_ => {
          this.ngbModal.open(this.modalRedacaoFoto, {size: 'lg'});
        });
      }
    });
  }

  verificarPermissoes() {
    if (this.redacao.horarioFinalizacao !== null) {
      this.router.navigateByUrl('/vagas/lista');
    }
  }

  tirarFotoFinal() {
    this.descricaoFoto = this.descricoesFoto.finalizacao;
    this.triggerSnapshot();
    this.ngbModal.dismissAll();
    this.router.navigateByUrl('/vagas/lista');
  }

  mascaraCPF(cpf: string): string {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
  }

  handleInitError(error: WebcamInitError) {
    fromPromise(this.router.navigateByUrl('/vagas/lista')).subscribe(_ => {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Ocorreu algum problema ao acessar sua câmera. Habilite sua câmera, atualize a página e acesse  novamente o link da prova discursiva.',
      });
    });
    console.log(error);
  }
}
